export default __webpack_public_path__ + "9311c288dee17bcb2dffa47a5fa499f6.png";